export default __webpack_public_path__ + "static/media/th.4e4eceb4.jpeg";